import Vue from 'vue';
import env from '../config'

export default {
    getKYCDetails (customerId) {
        return Vue.axios.get(`/api/v1/kyc/status/${customerId}`).then(response => response.data)
    },

    initiate (customerId) {
        return Vue.axios.post(`/api/v1/kyc/initiate`, {
            userReference: customerId,
            successUrl: env.jumio.successUrl,
            errorUrl: env.jumio.errorUrl
        }).then(response => response.data)
    }
}